import { useState, useContext } from "react";
import { Autocomplete, TextField, Typography } from "@mui/material";
import { UniversalDescriptorContext } from "../../../common/contexts/UniversalDescriptorContext";

export const UniversalDescriptorSelectCell = ({ row, onRowChange }) => {
  const { universalDescriptors } = useContext(UniversalDescriptorContext);
  const matchingUD = universalDescriptors.find(
    (ud) => ud.UD === row.UniversalDescriptor && ud.IsActive
  );
  const [selectedUD, setSelectedUD] = useState(matchingUD || null);

  return (
    <div style={{ paddingTop: "8px" }}>
      <Autocomplete
        size='small'
        options={universalDescriptors.filter((ud) => ud.IsActive)}
        getOptionLabel={(option) => option.UD}
        getOptionKey={(option) => option.UniversalDescriptorId}
        value={selectedUD}
        onChange={(_, newValue) => {
          setSelectedUD(newValue);
          onRowChange({ ...row, UniversalDescriptor: newValue?.UD || "" });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Search by UD'
            fullWidth
            sx={{ mb: 2 }}
          />
        )}
        isOptionEqualToValue={(option, value) =>
          option?.UniversalDescriptorId === value?.UniversalDescriptorId
        }
        noOptionsText={<Typography>No universal descriptors found.</Typography>}
        multiple={false}
        ListboxProps={{ style: { maxHeight: "200px" } }}
      />
    </div>
  );
};
